(function () {
  var STORAGE_KEY = "drawer_discount_code";

  function $(sel, root) {
    return (root || document).querySelector(sel);
  }

  function setNotiVisible(visible) {
    var noti = document.querySelector("[data-discount-noti]");
    if (!noti) return;
    noti.classList.toggle("hidden", !visible);
  }

  function getCode() {
    try { return (localStorage.getItem(STORAGE_KEY) || "").trim(); }
    catch (e) { return ""; }
  }

  function setCode(code) {
    try {
      if (!code) localStorage.removeItem(STORAGE_KEY);
      else localStorage.setItem(STORAGE_KEY, code);
    } catch (e) {}
    setNotiVisible(!!code);
  }

  function initCouponForm() {
    var wrap = document.querySelector("[data-coupon-form]");
    if (!wrap) return;

    var input = $("[data-coupon-input]", wrap);
    var applyBtn = $("[data-coupon-apply]", wrap);
    var removeBtn = $("[data-coupon-remove]", wrap);
    var msg = $("[data-coupon-msg]", wrap);

    var saved = getCode();
    if (saved) {
      input.value = saved;
      removeBtn.classList.remove("hidden");
      msg.textContent = "Coupon saved: " + saved;
    } else {
      removeBtn.classList.add("hidden");
      msg.textContent = "";
    }

    applyBtn.addEventListener("click", function () {
      var code = (input.value || "").trim();
      if (!code) {
        setCode("");
        removeBtn.classList.add("hidden");
        msg.textContent = "Coupon removed.";
        return;
      }
      setCode(code);
      removeBtn.classList.remove("hidden");
      msg.textContent = "Coupon saved. It will apply at checkout.";
    });

    removeBtn.addEventListener("click", function () {
      input.value = "";
      setCode("");
      removeBtn.classList.add("hidden");
      msg.textContent = "Coupon removed.";
    });
  }

  function interceptCheckout() {
    // your checkout button already has class scd__checkout
    var btn = document.querySelector(".scd__checkout");
    if (!btn || btn.dataset.couponBound === "1") return;

    btn.dataset.couponBound = "1";

    btn.addEventListener("click", function (e) {
      if (btn.hasAttribute("disabled")) return;

      var code = getCode();
      if (!code) return;

      e.preventDefault();
      e.stopPropagation();

      window.location.href =
        "/discount/" + encodeURIComponent(code) + "?redirect=/checkout";
    }, true);
  }

  // Run now and also re-run because drawers often re-render
  function boot() {
    initCouponForm();
    interceptCheckout();
  }

  boot();

  // Rebind a few times for ajax drawer updates
  var tries = 0;
  var timer = setInterval(function () {
    boot();
    tries++;
    if (tries > 10) clearInterval(timer);
  }, 500);
})();
